import React, { PureComponent } from "react";

//import Switch from "Common/Switch/Switch";
import { TTP_HUB_URL, TTP_ACCOUNTING_URL } from "Config";

import styles from "./Page.local.scss";
import classnames from "classnames";

import { convertDateFromUTC, getDateLabel } from "Utils";

import _ from "i18n";

export default class PageComponent extends PureComponent {
  selectPage = page => {
    const {
      indexSetting,
      setBlocLabel,
      setBlocUrl,
      setBlocIcon,
      setBlocApp,
      order
    } = this.props;
    const { id, title, resource } = page;

    let url = `${TTP_HUB_URL}/pages/${id}`;
    let icon = resource.toLowerCase();

    switch (resource) {
      case "DASHBOARD":
        url = `${TTP_ACCOUNTING_URL}/folders`;
        icon = "accounting";
        break;
      case "ALBUM":
        icon = "media";
        break;
      default:
    }

    setBlocApp(indexSetting, order, resource);
    setBlocLabel(indexSetting, order, title);
    setBlocUrl(indexSetting, order, url);
    setBlocIcon(
      indexSetting,
      order,
      `https://s3.tamtam.pro/v2/apps/${icon}.png`
    );
  };

  render() {
    const { openPageModal, page } = this.props;
    const { id, title, resource, createdAt } = page;

    let icon = resource.toLowerCase();

    switch (resource) {
      case "DASHBOARD":
        icon = "accounting";
        break;
      case "ALBUM":
        icon = "media";
        break;
    }

    return (
      <div className={styles.page}>
        <div className={styles.icon}>
          <img src={`https://s3.tamtam.pro/v2/apps/${icon}.png`} alt="" />
        </div>
        <div className={styles.content}>
          <span>{getDateLabel(convertDateFromUTC(createdAt))}</span>
        </div>
        <div className={styles.actions}>
          <h3>{title}</h3>
          <div className={styles.controls}>
            <span onClick={openPageModal.bind(this, page)}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M15.8215 7.38423C14.988 6.02114 13.8674 4.9259 12.4598 4.09855C11.052 3.27116 9.56549 2.85742 8 2.85742C6.43451 2.85742 4.94793 3.27101 3.54018 4.09855C2.1324 4.9259 1.01183 6.02114 0.178505 7.38423C0.0595122 7.59254 0 7.7979 0 8.00033C0 8.20276 0.0595122 8.40813 0.178505 8.61638C1.01183 9.97953 2.1324 11.0749 3.54018 11.902C4.94793 12.7295 6.43451 13.1429 8 13.1429C9.56552 13.1429 11.052 12.7309 12.4598 11.9065C13.8674 11.0821 14.9882 9.98538 15.8215 8.61638C15.9405 8.40813 16 8.20286 16 8.00033C16 7.7979 15.9405 7.59254 15.8215 7.38423ZM6.08469 4.94223C6.6174 4.40952 7.25577 4.14308 7.99991 4.14308C8.1189 4.14308 8.22016 4.18486 8.30353 4.26814C8.38678 4.35145 8.42863 4.45268 8.42863 4.57171C8.42863 4.69082 8.38678 4.79199 8.30372 4.87518C8.22047 4.95858 8.11915 5.00024 8.00012 5.00024C7.48825 5.00024 7.05062 5.18187 6.68757 5.54488C6.3244 5.90812 6.14292 6.34556 6.14292 6.85744C6.14292 6.97662 6.10114 7.07772 6.01786 7.1611C5.93446 7.24453 5.83332 7.28616 5.7143 7.28616C5.59518 7.28616 5.49401 7.24444 5.41064 7.1611C5.32724 7.07772 5.28558 6.97649 5.28558 6.85744C5.28558 6.11346 5.55202 5.47496 6.08469 4.94223ZM11.8795 10.9157C10.686 11.6387 9.39289 12.0004 8 12.0004C6.60714 12.0004 5.31401 11.6389 4.12057 10.9157C2.92714 10.1924 1.93457 9.22066 1.14293 8.00033C2.04768 6.59553 3.18161 5.54485 4.54469 4.84856C4.18162 5.46752 4.00002 6.13722 4.00002 6.85741C4.00002 7.95871 4.39146 8.90043 5.17412 9.68328C5.95679 10.4661 6.89885 10.8574 8 10.8574C9.10124 10.8574 10.043 10.4659 10.8259 9.68328C11.6087 8.90065 12 7.95871 12 6.85741C12 6.13722 11.8184 5.46742 11.4553 4.84856C12.8183 5.54485 13.9523 6.59562 14.857 8.00033C14.0655 9.22066 13.073 10.1924 11.8795 10.9157Z"
                  fill="currentColor"
                />
              </svg>
            </span>
            <span
              className={styles.check}
              onClick={this.selectPage.bind(this, page)}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Bloc/Pages/Page/PageComponent.js